function IconCards({ size = 24, color = '#1a1a1a' }: { size?: number; color?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0001 4H16.0001C16.2653 4 16.5196 4.10536 16.7072 4.29289C16.8947 4.48043 17.0001 4.73478 17.0001 5V8.5M20.0001 6C20.2641 6.112 20.5201 6.217 20.7681 6.315C21.0122 6.41859 21.2052 6.6149 21.3045 6.86075C21.4039 7.1066 21.4016 7.38187 21.2981 7.626L19.0001 13M3.60406 7.197L10.7421 4.088C10.8598 4.03752 10.9865 4.01112 11.1147 4.01038C11.2428 4.00964 11.3698 4.03456 11.4882 4.08368C11.6066 4.13279 11.7139 4.20511 11.8039 4.29636C11.8938 4.38761 11.9646 4.49595 12.0121 4.615L16.9361 16.517C17.0373 16.7585 17.0403 17.0299 16.9443 17.2735C16.8482 17.5171 16.6609 17.7136 16.4221 17.821L9.28506 20.93C9.16722 20.9806 9.04043 21.0072 8.91217 21.008C8.78392 21.0088 8.6568 20.9839 8.53832 20.9348C8.41984 20.8857 8.31241 20.8133 8.22236 20.722C8.13232 20.6306 8.06149 20.5222 8.01406 20.403L3.09006 8.5C2.98904 8.25851 2.98623 7.98714 3.08222 7.74361C3.17821 7.50008 3.36544 7.30461 3.60406 7.197Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

IconCards.displayName = 'IconCards';

export default IconCards;
